/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_DescriptionInputs */

const en_gc_guides_start_description = /** @type {(inputs: Gc_Guides_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how to open an Excel XLSX file in GridCraft online, make a small edit, check a formula and download your updated workbook.`)
};

const zh_gc_guides_start_description = /** @type {(inputs: Gc_Guides_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习在 GridCraft 中在线打开 Excel XLSX 文件，进行简单编辑、检查公式并下载更新后的工作簿。`)
};

/**
* | output |
* | --- |
* | "Learn how to open an Excel XLSX file in GridCraft online, make a small edit, check a formula and download your updated workbook." |
*
* @param {Gc_Guides_Start_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_description = /** @type {((inputs?: Gc_Guides_Start_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_description(inputs)
	return zh_gc_guides_start_description(inputs)
});
export { gc_guides_start_description as "gc.guides.start.description" }